import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { _danhSachDongSanPham, _danhSachLoaiPhuKien, _danhSachMaPhuKien, _danhSachThuongHieu } from '../../api/baoHanh';
import BannerImage from '../../assets/image/banner-phukien.jpg';
import Search from 'antd/es/input/Search';
import Paginations from '../layout/pagination';
import { formatCurrency } from '../../helper/formatNumber';
import { setLoading } from '../../redux/loading/action';
import { Modal } from 'antd';
const PhuKien = () => {
    const dispatch = useDispatch();
    const [selectedIndex, setSelectedIndex] = useState([]);
    const [selectedIndexThuongHieu, setselectedIndexThuongHieu] = useState([]);
    const [selectedIndexSPTT, setselectedIndexSPTT] = useState([]);

    const danhSachThuongHieu = useSelector((store) => store.categories.danhSachThuongHieu);

    const [body, setBody] = useState({});
    const [danhSachPhuKienEcovacs, setDanhSachPhuKienEcovacs] = useState([]);
    const [danhSachLoaiPhuKienEcovacs, setDanhSachLoaiPhuKienEcovacs] = useState([]);
    const [danhSachDongSanPhamEcovacs, setDanhSachDongSanPhamEcovacs] = useState([]);
    const [danhSachThuongHieuEcovacs, setDanhSachThuongHieuEcovacs] = useState([]);

    const [thuonghieu, setThuongHieu] = useState(null);
    const [loaiphukien, setLoaiPhuKien] = useState([]);

    const [IdSanPhamTuongThich, setIdSanPhamTuongThich] = useState([]);

    const [tukhoa, setTuKhoa] = useState('');
    const [sptt, setSPTT] = useState('');
    const [showAll, setShowAll] = useState(false);
    const [showAllMenu, setShowAllMenu] = useState(false);
    const [showMegaThuongHieu, setShowMegaThuongHieu] = useState(false);
    const [showMegaCategory, setShowMegaCategory] = useState(false);

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(12);
    const [totalProducts, setTotalProducts] = useState(0);
    const [isModalFile, setisModalFile] = useState(false);

    const [categoryId, setCategoryId] = useState('');

    const handleClick = (index) => {
        setSelectedIndex((prevSelected) => {
            let newList;

            if (prevSelected.includes(index)) {
                newList = prevSelected.filter((i) => i !== index);
            } else {
                newList = [...prevSelected, index];
            }

            setLoaiPhuKien(newList);

            const data = {
                ...body,
                IdLoaiPhuKien: newList.length > 0 ? newList : undefined,
            };

            if (!newList.length) delete data.IdLoaiPhuKien;

            setBody(data);
            searchMaPhuKien(data);

            return newList;
        });
    };

    useEffect(() => {
        if (categoryId) {
            dispatch(danhSachThuongHieu(categoryId));
        }
    }, [categoryId]);

    const onLoadData = async () => {
        await dispatch(setLoading(true));
        try {
            const [danhSachPhuKien, danhSachThuongHieu] = await Promise.all([_danhSachMaPhuKien(body), _danhSachThuongHieu()]);
            setDanhSachPhuKienEcovacs(danhSachPhuKien);
            setDanhSachThuongHieuEcovacs(danhSachThuongHieu);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            await dispatch(setLoading(false));
        }
    };

    useEffect(() => {
        onLoadData();
    }, []);

    const getThuongHieu = async (thuonghieu) => {
        setselectedIndexThuongHieu([thuonghieu]);
        setThuongHieu(thuonghieu);

        setSelectedIndex([]);
        setLoaiPhuKien([]);
        setSPTT('');
        setselectedIndexSPTT([]);
        setIdSanPhamTuongThich('');

        const data = {
            IdThuongHieu: thuonghieu,
        };

        setBody(data);
        searchMaPhuKien(data);

        _danhSachLoaiPhuKien(thuonghieu).then(setDanhSachLoaiPhuKienEcovacs);
        _danhSachDongSanPham(thuonghieu).then(setDanhSachDongSanPhamEcovacs);
    };

    const onMouseEnter = (id) => {
        setCategoryId(id);
    };

    const searchSanPham = async (id, name) => {
        setselectedIndexSPTT([id]);
        setIdSanPhamTuongThich(id);
        setSPTT(name);

        const data = {
            ...body,
            idSanPhamTuongThich: id,
        };

        setBody(data);
        await searchMaPhuKien(data);
    };

    // useEffect(() => {
    //     searchSanPham(selectedIndexSPTT);
    // }, [selectedIndexSPTT]);

    const searchMaPhuKien = (data) => {
        _danhSachMaPhuKien(data)
            .then((res) => {
                setDanhSachPhuKienEcovacs(res);
            })
            .catch((error) => {});
    };

    const showModalFile = () => {
        setisModalFile(true);
    };

    const handleOk = () => {
        setisModalFile(false);
    };

    const handleCancel = () => {
        setisModalFile(false);
    };

    const onSearch = async (value) => {
        setTuKhoa(value);

        const data = {
            ...(value && { tenHang: value }),
            ...(thuonghieu && { IdThuongHieu: thuonghieu }),
            ...(IdSanPhamTuongThich && {
                idSanPhamTuongThich: IdSanPhamTuongThich,
            }),
            ...(loaiphukien.length > 0 && {
                IdLoaiPhuKien: loaiphukien,
            }),
        };

        setBody(data);

        _danhSachMaPhuKien(data).then(setDanhSachPhuKienEcovacs).catch(console.error);
    };

    const removeThuongHieu = () => {
        setThuongHieu('');
        setSelectedIndex([]);
        setLoaiPhuKien([]);
        setSPTT('');
        setselectedIndexSPTT([]);
        setIdSanPhamTuongThich('');

        const data = {};
        setBody(data);
        searchMaPhuKien(data);
    };

    const removeSPTT = () => {
        setSPTT('');
        setselectedIndexSPTT([]);
        setIdSanPhamTuongThich('');

        const data = {
            ...body,
        };

        delete data.idSanPhamTuongThich;

        setBody(data);
        searchMaPhuKien(data);
    };

    const removeTuKhoa = () => {
        setTuKhoa('');

        const data = {
            ...body,
        };

        delete data.tenHang;

        setBody(data);
        searchMaPhuKien(data);
    };

    return (
        <div className="product-selector">
            <div className="banner-image position-relative">
                <figure className="image img-fluid">
                    <img src={BannerImage} className="w-100" />
                </figure>
            </div>
            <div className="container">
                {!thuonghieu && (
                    <div className="res_pc">
                        <div className="fw-bold text-primary my-4 text-center" style={{ fontSize: '21px' }}>
                            Bạn đang tìm kiếm phụ kiện của thương hiệu nào?
                        </div>
                        <div className="col-md-12 phukien_filter mt-3">
                            {danhSachThuongHieuEcovacs &&
                                danhSachThuongHieuEcovacs
                                    .filter((x) => x.CmsSttHienWeb)
                                    .slice(0, showAllMenu ? undefined : 11)
                                    .map((item, index) => (
                                        <div key={index} onClick={() => getThuongHieu(item.MaNhomHangChiTiet)} className="col-md-2 tab_thuonghieu d-flex align-items-center justify-content-center mb-3">
                                            <img src={item.CmsImageLink} alt={item.TenThuongHieu} />
                                        </div>
                                    ))}

                            {!showAllMenu && danhSachThuongHieuEcovacs?.length > 11 && (
                                <div className="col-md-2 tab_thuonghieu d-flex align-items-center justify-content-center mb-3" onClick={() => setShowAllMenu(true)} style={{ cursor: 'pointer' }} title="Xem thêm thương hiệu khác">
                                    <span className="fw-bold text-primary">Xem thêm …</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <div className="card timkiem_filter mt-3">
                    <div className="card-header d-block mb-0">
                        <div className="filter_product m-2">
                            <div className="list-search-category list-thuonghieu" style={{ display: 'flex' }} onClick={() => setShowMegaThuongHieu((prev) => !prev)}>
                                <div className="text-primary" style={{ marginRight: '31px' }}>
                                    Tìm kiếm:
                                </div>
                                Thương hiệu&nbsp;
                                <span>
                                    :<span className="text-primary"> {thuonghieu} </span>
                                </span>
                                &nbsp;
                                <i className="fa fa-caret-down cursor-pointer" />
                                <div className="row">
                                    <div className={`w-100 mega-thuonghieu col-md-12 phukien_filter rounded p-3 ${!thuonghieu ? 'hoverable' : ''} ${showMegaThuongHieu && thuonghieu ? 'clicked' : ''}`}>
                                        {danhSachThuongHieuEcovacs &&
                                            (showAll ? danhSachThuongHieuEcovacs.filter((x) => x.CmsSttHienWeb) : danhSachThuongHieuEcovacs.filter((x) => x.CmsSttHienWeb).slice(0, 11)).map((item, index) => (
                                                <div key={index} style={{ width: '100%' }} className="col-md-2 tab_thuonghieu">
                                                    <div
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            getThuongHieu(item.MaNhomHangChiTiet);
                                                            setShowMegaThuongHieu(false);
                                                        }}
                                                        className={`sub-label fw-bold text-primary tab_thuonghieu img cursor-pointer ${thuonghieu === item.MaNhomHangChiTiet ? 'active' : ''}`}
                                                    >
                                                        <img src={item.CmsImageLink} alt={item.TenThuongHieu || 'Brand'} />
                                                    </div>
                                                </div>
                                            ))}

                                        {!showAll && danhSachThuongHieuEcovacs?.length > 11 && (
                                            <div style={{ width: '100%' }} className="col-md-2 tab_thuonghieu d-flex align-items-center justify-content-center" onClick={() => setShowAll(true)} title="Xem thêm thương hiệu khác">
                                                <div className="sub-label fw-bold text-primary fs-3 cursor-pointer">…</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="list-category" tabIndex="0" onMouseEnter={() => onMouseEnter()}>
                                Sản phẩm tương thích&nbsp;
                                <span>
                                    : <span className="text-primary">{sptt}</span>
                                </span>
                                &nbsp;
                                <i className="fa fa-caret-down" />
                                <div className={`w-100 mega-category rounded p-3 ${!sptt ? 'hoverable' : ''} ${showMegaCategory && sptt ? 'clicked' : ''}`}>
                                    <div className="row">
                                        {danhSachDongSanPhamEcovacs &&
                                            danhSachDongSanPhamEcovacs
                                                .sort((a, b) => a.SttHienThi - b.SttHienThi)
                                                .map((item, index) => (
                                                    <div key={index} className={item.length > 0 ? 'col-md-3 list' : 'col-md-3 only'}>
                                                        <div className="col-md-12 li">
                                                            <div className="sub-label fw-bold text-primary cursor-pointer">{item.TenDongSanPham}</div>
                                                        </div>
                                                        <div className="row" key={index}>
                                                            {item.SanPhamTuongThich &&
                                                                item.SanPhamTuongThich.length > 0 &&
                                                                item.SanPhamTuongThich.sort((a, b) => a.STT_HIEN_THI - b.STT_HIEN_THI).map((i, index) => (
                                                                    <div
                                                                        className="sub-child-label cursor-pointer"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            searchSanPham(i.ID, i.TEN_SAN_PHAM_TUONG_THICH);
                                                                            setShowMegaCategory(false);
                                                                        }}
                                                                        key={index}
                                                                    >
                                                                        {i.TEN_SAN_PHAM_TUONG_THICH}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </div>
                                                ))}
                                    </div>
                                </div>
                            </div>

                            <div className="list-search-category" style={{ width: '40%' }}>
                                <Search placeholder="Gõ từ khóa muốn tìm " enterButton="Tìm kiếm" size="large" suffix={''} onSearch={onSearch} />
                            </div>
                        </div>
                    </div>

                    {(thuonghieu || sptt || tukhoa) && (
                        <div className="card-body">
                            <div className="d-flex align-items-center p-2">
                                <span>Đã chọn:</span>
                                {thuonghieu && (
                                    <span className="badge bg-primary ms-2 cursor-pointer p-2" style={{ fontSize: '13px' }} onClick={removeThuongHieu}>
                                        {thuonghieu} <i className="fa fa-times ms-1"></i>
                                    </span>
                                )}

                                {sptt && (
                                    <span className="badge bg-primary ms-2 cursor-pointer p-2" style={{ fontSize: '13px' }} onClick={removeSPTT}>
                                        {sptt} <i className="fa fa-times ms-1"></i>
                                    </span>
                                )}

                                {tukhoa && (
                                    <span className="badge bg-primary ms-2 cursor-pointer p-2" style={{ fontSize: '13px' }} onClick={removeTuKhoa}>
                                        {tukhoa} <i className="fa fa-times ms-1"></i>
                                    </span>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <div className="card_mobile mt-3">
                    <div onClick={() => showModalFile()} className="filter-wrap" style={{ marginRight: '31px' }}>
                        <svg className="icon icon-filter" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5 1H1.5V3.47059L6.375 8.41176V15L9.625 12.9412V8.41176L14.5 3.47059V1Z" stroke="#111111" stroke-width="1.5" stroke-linejoin="round"></path>
                        </svg>
                        Bộ lọc:
                    </div>
                    <div className="list-search-categorys">
                        <Search placeholder="Gõ từ khóa muốn tìm " enterButton="Tìm kiếm" size="large" suffix={''} onSearch={onSearch} />
                    </div>
                </div>

                <div className="col-md-12 phukien_filter res_pc mt-3">
                    {danhSachLoaiPhuKienEcovacs?.map((item, index) => (
                        <div key={index} onClick={() => handleClick(item.ID)} className={`col-md-2 tab_product ${selectedIndex.includes(item.ID) ? 'selected' : ''}`}>
                            {item.TEN_LOAI_PHU_KIEN}
                        </div>
                    ))}
                </div>
                <div className="row mt-4">
                    <div className="col-md-12">
                        <div className="product-item-selector">
                            {danhSachPhuKienEcovacs?.length > 0 ? (
                                danhSachPhuKienEcovacs?.map((item, index) => (
                                    <div key={index} className="list-item-selector">
                                        <div className="card-product-selector">
                                            <div className="d-item d-inline-block">
                                                <img src={item.AnhHienThi} className="w-100 img-product-selector" loading="lazy" alt={item.thumb_ecovacs} />
                                            </div>
                                            <div className="info-product p-2">
                                                <div className="info-detail">
                                                    <h5 className="mb-2">
                                                        <div className="require">{formatCurrency(item.GiaBan)}đ</div>

                                                        <div className="text-primary ma_chuan my-2" style={{ fontSize: '18px' }}>
                                                            {' '}
                                                            {item.MaChuan}
                                                        </div>

                                                        <div className="ten_hang_hien_thi my-2">{item.TenHangHienThi}</div>
                                                    </h5>
                                                </div>
                                                <div className="box-detail">
                                                    <a target="_blank" key={item.Id} className="item-news" href={item.LinkGiga} rel="noreferrer">
                                                        <p className="text-detail">Xem chi tiết </p>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <h6>Không có phụ kiện</h6>
                            )}
                        </div>

                        <div className="w-100 my-3">
                            <Paginations page={page} setPage={setPage} perPage={perPage} totalItem={totalProducts} />
                        </div>
                    </div>
                </div>
            </div>
            <Modal width={1800} style={{ zIndex: '99' }} title="Bộ lọc tìm kiếm" open={isModalFile} okText="Tra cứu" onOk={handleOk} onCancel={handleCancel}>
                <div className="list-filter--main">
                    <div>
                        <div className="filter-group--block">
                            <div className="filter-group--title jsTitle">
                                <span>20</span>
                            </div>
                            <div className="filter-group--content">
                                {danhSachThuongHieuEcovacs &&
                                    danhSachThuongHieuEcovacs
                                        .filter((x) => x.CmsSttHienWeb == true)
                                        .map((item, index) => (
                                            <>
                                                <div key={index}>
                                                    <label
                                                        onClick={() => getThuongHieu(item.MaNhomHangChiTiet)}
                                                        className={`sub-label fw-bold text-primary tab_thuonghieu img cursor-pointer ${selectedIndexThuongHieu.includes(item.MaNhomHangChiTiet) ? 'selected' : ''}`}
                                                        key={index}
                                                    >
                                                        <img src={item.CmsImageLink} />
                                                    </label>
                                                </div>
                                            </>
                                        ))}
                            </div>
                            <br />
                            <div className="line"></div>
                            <div className="filter-group--title jsTitle">
                                <span>Sản phẩm tương thích</span>
                            </div>
                            <div className="filter-group--contents">
                                {danhSachDongSanPhamEcovacs &&
                                    danhSachDongSanPhamEcovacs
                                        .sort((a, b) => a.STT_HIEN_THI - b.STT_HIEN_THI)
                                        .map((item, index) => (
                                            <div key={index} className={item.length > 0 ? 'col-md-3 list' : 'col-md-3 only'}>
                                                <div className="col-md-12 li">
                                                    <div className="sub-label fw-bold text-primary cursor-pointer">{item.TenDongSanPham}</div>
                                                </div>
                                                <div className="row" key={index}>
                                                    {item.SanPhamTuongThich &&
                                                        item.SanPhamTuongThich.length > 0 &&
                                                        item.SanPhamTuongThich.sort((a, b) => a.STT_HIEN_THI - b.STT_HIEN_THI).map((i, e) => (
                                                            <div className={`sub-child-label tab_sptt img cursor-pointer ${selectedIndexSPTT.includes(i.ID) ? 'selected' : ''}`} onClick={() => searchSanPham(i.ID, i.TEN_SAN_PHAM_TUONG_THICH)} key={e}>
                                                                {i.TEN_SAN_PHAM_TUONG_THICH}
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        ))}
                            </div>

                            <br />
                            <div className="line"></div>
                            <div className="filter-group--title jsTitle">
                                <span>Loại phụ kiện</span>
                            </div>
                            <div className="filter-group--title jsTitle">
                                <div className="filter-group--contents">
                                    {danhSachLoaiPhuKienEcovacs?.map((item, index) => (
                                        <div key={index} onClick={() => handleClick(item.ID)} className={`col-md-2 tab_product ${selectedIndex.includes(item.ID) ? 'selected' : ''}`}>
                                            {item.TEN_LOAI_PHU_KIEN}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default PhuKien;
